import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import useUser from "../../core/user/useUser";
import { deleteOrganization } from "../../core/api/organizations/organizations";
import { notify } from "../../ui-lib/components/Alerts/Toast";
import useTranslations from "../../core/i18n/useTranslations";
import PrimeModal from "../../ui-lib/components/PrimeModal/PrimeModal";
import { notifyApiErrors } from "../../core/helpers/helpers";
import { PopupContextMenuLinkButton } from "../../ui-lib/components/Menus/PopupContextMenu/PopupContextMenuLinkButton";

const DeleteOrganizationModal = () => {
  const t = useTranslations();
  const { id } = useParams<{ id: string }>();
  const { authenticatedRequest } = useUser();
  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onDelete = async () => {
    setLoading(true);
    try {
      await deleteOrganization(id, authenticatedRequest);
      notify({
        message: t("Common:delete_success").replace(
          "{type}",
          t("Common:organisation")
        ),
      });
      history.replace("/adminportal/organizations");
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PopupContextMenuLinkButton
        icon="trash"
        text={t("Organizations:delete_organisation")}
        onClick={() => setOpen(true)}
      />
      <PrimeModal
        withFooter
        withHeader
        header={t("Common:delete_modal_title").replace(
          "{type}",
          t("Organizations:type")
        )}
        loading={loading}
        isOpen={open}
        onClose={() => setOpen(false)}
        fixedWidth="576px"
        submitBtn={{
          text: t("Organizations:delete_organisation"),
          onClick: onDelete,
          variant: "destructive",
        }}
        cancelBtn={{ text: t("Common:cancel"), onClick: () => setOpen(false) }}
      >
        <p className="grey-600">
          {t("Common:delete_modal_confirm").replace(
            "{type}",
            t("Organizations:type")
          )}
        </p>
      </PrimeModal>
    </>
  );
};

export default observer(DeleteOrganizationModal);
